import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { PageLoading } from '@/app/ui/page';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const Auth0ErrorPage = LoadComponentWithRetry(() => import('./Auth0ErrorPage'), <PageLoading variant="app" />);

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/error`} component={Auth0ErrorPage} />
    </Switch>
  );
};

export default Routes;
